import React from 'react'
import { Box } from '@mui/material'
import { tagContainer, tagIcon, tagText } from '../style'

interface Props {
    text: string
    icon: string
}

const CourseTag: React.FC<Props> = ({ text, icon }) => {
    return (
        <Box sx={tagContainer}>
            <img
                src={icon}
                style={tagIcon}
            />

            <Box sx={tagText}>{text}</Box>
        </Box>
    )
}

export default CourseTag
